import React, { forwardRef, type Ref } from 'react';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

type MenuTriggerButtonProps = Omit<IconButtonProps, 'spacing' | 'icon' | 'label'>;

export const MenuTriggerButton = forwardRef(
	({ onClick, name, ...props }: MenuTriggerButtonProps, ref: Ref<HTMLButtonElement>) => {
		const { formatMessage } = useIntl();

		return (
			<IconButton
				{...props}
				icon={(iconProps) => (
					<ShowMoreHorizontalIcon {...iconProps} color={token('color.icon')} size="small" />
				)}
				label={
					fg('jsm_aiiy_for_nav_item_sidebar')
						? formatMessage(messages.projectActionsMenuName, { name })
						: formatMessage(messages.projectActionsMenu)
				}
				onClick={onClick}
				ref={ref}
				spacing="compact"
				appearance="subtle"
				testId="navigation-project-action-menu.ui.menu-container.themed-button"
				isTooltipDisabled={false}
				tooltip={{
					content: formatMessage(messages.projectActionsMenu),
					hideTooltipOnClick: true,
				}}
			/>
		);
	},
);
